import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { Course } from "~/providers/course-provider";

interface OrderChartStoreState {
  orderChartFormOpen: boolean;
  selectedOrderChart?: Course;
  setSelectedOrderChart: (selectedOrderChart?: Course) => void;
  setOrderChartFormOpen: (open: boolean) => void;
}

export const useOrderChartStore = create<OrderChartStoreState>()(
  devtools((set) => ({
    orderChartFormOpen: false,
    setSelectedOrderChart(selectedOrderChart) {
      set(() => ({ selectedOrderChart: selectedOrderChart }));
    },
    setOrderChartFormOpen(open) {
      set(() => ({ orderChartFormOpen: open }));
    },
  })),
);
